import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
//import ReactQuill from 'react-quill'
import CKEditor from "react-ckeditor-component"

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import { 
	displayModalCreate,
	updateInputs,
	createOrUpdateGarantias
} from '../../actions/garantias'

class ModalCreate extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalCreate')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreate .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCreate(false, '', ''), 300)
	}

	render() {
		const { modalCreate } = this.props
		if (!modalCreate.get('show')) {
			return null
		}

		return(
			<Modal id="modalCreate" show={ true } ZIndex={ 2000 } style={{ width: '70vw' }} >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.createOrUpdateGarantias(modalCreate.get('data'), modalCreate.get('mode')) }} noValidate>
					<ModalHeader title={ modalCreate.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="floppy-o" disabled={ modalCreate.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>
					<ModalBody >
						<div>
							<div className="row">
								<div className="col-md-3">
									<div className="form-group">
                                        <label className="control-label">Nombre</label>
                                        <input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'nombre']) } onChange={ (e) => this.props.updateInputs(`modalCreate.data.nombre`, e.target.value) } disabled={ modalCreate.get('mode') === 'edit' } />
                                    </div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<div className="form-group">
                                        <label className="control-label">Garantia</label>
										<CKEditor activeClass="p10" content={ modalCreate.getIn(['data', 'texto']) } events={{ "change": (e) => this.props.updateInputs(`modalCreate.data.texto`, e.editor.getData()) }} />
                                    </div>
								</div>
							</div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalCreate: state.garantias.get('modalCreate'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalCreate: (show, title, mode) => dispatch(displayModalCreate(show, title, mode)),
		updateInputs: (path, value) => dispatch(updateInputs(path, value)),
		createOrUpdateGarantias: (data, mode) => dispatch(createOrUpdateGarantias(data, mode)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate)



// WEBPACK FOOTER //
// ./src/components/Garantias/ModalCreate.jsx